import { CanvasImageSourceWithoutSVG, getImageDimensions } from './getImageDimensions';

export function getResizedImageDimensions(
  image: CanvasImageSourceWithoutSVG,
  maxWidth: number,
  maxHeight: number
): { width: number; height: number } {
  let { width, height } = getImageDimensions(image);

  if (width > maxWidth) {
    const ratio = maxWidth / width;
    width *= ratio;
    height *= ratio;
  }
  if (height > maxHeight) {
    const ratio = maxHeight / height;
    width *= ratio;
    height *= ratio;
  }

  return { width, height };
}
